import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ChevronDown from '@spectrum-icons/workflow/ChevronDown';
import ChevronUp from '@spectrum-icons/workflow/ChevronUp';
import { PrimaryButton } from '../../buttons/PrimaryButton';
import { withTheme } from '../../ThemeProvider';
import styles from './PrimaryDropdown.module.less';
import DropdownMenu from '../DropdownMenu';

const PrimaryDropdown = ({ children, options, onSelectionChange, ...props }) => {
  const [open, setOpen] = useState(false);

  const ref = useRef(null);
  const buttonRef = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target) && !buttonRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener('click', handleClickOutside, true);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return (
    <div className={styles.container} ref={buttonRef}>
      <PrimaryButton
        onClick={(e) => {
          setOpen(!open);
          e.stopPropagation();
        }}
        {...props}
      >
        <>
          {children} {(!open && <ChevronDown size="M" />) || <ChevronUp size="M" />}
        </>
      </PrimaryButton>
      <div ref={ref} className={styles.menuWrapper}>
        {open && <DropdownMenu options={options} onSelectionChange={onSelectionChange} />}
      </div>
    </div>
  );
};

PrimaryDropdown.propTypes = {
  children: PropTypes.node.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
  onSelectionChange: PropTypes.func,
};

PrimaryDropdown.defaultProps = {
  onSelectionChange: () => {},
};

PrimaryDropdown.displayName = 'PrimaryDropdown';

export default withTheme(PrimaryDropdown);
